"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchStudyCustomDataCrfFilesResponse = exports.SearchStudyCustomDataCrfsResponse = void 0;
class SearchStudyCustomDataCrfsResponse {
}
exports.SearchStudyCustomDataCrfsResponse = SearchStudyCustomDataCrfsResponse;
class SearchStudyCustomDataCrfFilesResponse {
}
exports.SearchStudyCustomDataCrfFilesResponse = SearchStudyCustomDataCrfFilesResponse;
//# sourceMappingURL=studyCustomDataCrf.js.map